import { generalConstants } from "@/utils/constants"

export const getOrderItemStatus = (lineItem) => {
    const isGiftCard = lineItem?.node?.variant?.selectedOptions.find((option) => option.name === generalConstants.gift_card_option_name) ? true : false
    const isDonationItem = lineItem?.node?.variant?.product?.tags.find((tag) => tag === generalConstants.product_type_donation_tag) ? true : false
    const isRefunded = lineItem?.node?.isRefunded
    const isDelivered = lineItem?.node?.isDelivered

    switch (true) {
        case lineItem?.node?.fulfillmentStatus === "unfulfilled" && !isGiftCard && !isDonationItem && !isRefunded && !isDelivered:
            return "Processing"
        case lineItem?.node?.fulfillmentStatus === "fulfilled" && !isGiftCard && !isDonationItem && !isRefunded && !isDelivered:
            return "Shipped"
        case isRefunded:
            return "Refunded"
        case isGiftCard:
            return "Completed"
        case isDonationItem:
            return "Donated"
        case isDelivered:
            return "Delivered"
        default:
            return ""
    }
}
